import React from 'react';
import { useTranslation } from 'react-i18next';
import CheckList from './checkList';
import useTitle from '../comnon/title';

const Dashboard = () => {
    const { t } = useTranslation();
    useTitle(t('home.view_title'));
    return (
        <>
            <CheckList />
        </>

    );

};

export default Dashboard;
